import { ref } from 'vue'

// 说明：原先还有一个 isLoggedIn ref，但它只有 emitLogin 写入、全项目零处读取，
// 属于死状态，已删除。登录态统一由 src/stores/authState.js 负责。
const listeners = []

const globalUser = ref(null) // 添加全局用户状态

// 添加新的事件系统
const events = {}

export const eventBus = {
    emitLogin() {
        listeners.forEach(listener => listener())
    },

    onLogin(callback) {
        listeners.push(callback)
    },

    offLogin(callback) {
        const index = listeners.indexOf(callback)
        if (index > -1) {
            listeners.splice(index, 1)
        }
    },

    // 用户状态管理方法
    setUser(user) {
        globalUser.value = user
    },

    clearUser() {
        globalUser.value = null
    },

    // 获取全局用户状态（供组件使用）
    getGlobalUser() {
        return globalUser
    },


    // 新增：通用事件系统
    on(event, callback) {
        if (!events[event]) {
            events[event] = []
        }
        events[event].push(callback)
    },

    off(event, callback) {
        if (!events[event]) return
        const index = events[event].indexOf(callback)
        if (index > -1) {
            events[event].splice(index, 1)
        }
    },

    emit(event, data) {
        if (!events[event]) return
        // 复制数组避免在遍历时被修改
        const callbacks = [...events[event]]
        callbacks.forEach(callback => {
            try {
                callback(data)
            } catch (error) {
                console.error(`Error in event handler for ${event}:`, error)
            }
        })
    }
}